import * as React from 'react';

import { SearchResponse } from '@algolia/client-search';

import { withExceptionCatcher } from '@/components/hoc/with-exception-catcher';
import SearchPageLayout from '@/components/pages/search/layout/search-page-layout';

export interface SearchPageControllerProps {
    initialResults: SearchResponse<any>;
}

export const SearchPageController = (props: SearchPageControllerProps) => {
    return <SearchPageLayout {...props} />;
};

export default withExceptionCatcher(SearchPageController);
